export default __webpack_public_path__ + "static/media/Ballroll_00223.79f94af8.png";